import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RpcError, StatusCode } from 'grpc-web';
import { API_URL, getCurrentLng, getHeaders, ApiMessage, toApiMessage, APIRequest, APIResponse, refreshSession, getSession, ACCOUNTANT_API_URL } from '../../../../app/Api';
import { formatDate, timestampToDate } from '../../../../app/Helpers';
import { AccountTypeEndpointClient } from '../../../../repository/Accountant/Account_typeServiceClientPb';
import { GetAccountTypesRequest, GetAccountTypesResponse } from '../../../../repository/Accountant/account_type_pb';
import { CurrencyEndpointClient } from '../../../../repository/Accountant/CurrencyServiceClientPb';
import { GetCurrenciesRequest, GetCurrenciesResponse } from '../../../../repository/Accountant/currency_pb';
import { LimitationEndpointClient } from '../../../../repository/Accountant/LimitationServiceClientPb';
import { GetLimitationsRequest, GetLimitationsResponse } from '../../../../repository/Accountant/limitation_pb';
import { RoleEndpointClient } from '../../../../repository/UserManagement/Customers/RoleServiceClientPb';
import { GetRolesRequest, GetRolesResponse } from '../../../../repository/UserManagement/Customers/role_pb';
import { UserTypeEndpointClient } from '../../../../repository/UserManagement/Customers/UsertypeServiceClientPb';
import { GetUserTypesRequest, GetUserTypesResponse } from '../../../../repository/UserManagement/Customers/usertype_pb';
import { OrganizationClientPortalSettingEndpointClient } from '../../../../repository/UserManagement/OrganizationclientportalsettingServiceClientPb';
import {
    GetOrganizationClientPortalSettingRequest, GetOrganizationClientPortalSettingResponse, RemoveOpenAccountDefaultConfigurationRequest,
    UpdateOpenAccountDefaultConfigurationRequest, UpdateOpenAccountDefaultConfigurationResponse, UpdateURLsRequest, UpdateURLsResponse, UpdateCurrencyPairsConfigurationRequest
    , RemoveOpenAccountDefaultConfigurationResponse, UpdateClientConfigurationRequest, UpdateClientConfigurationResponse, UpdateCanSignUpRequest, UpdateCanSignUpResponse, RemoveCurrencyPairsConfigurationResponse, RemoveCurrencyPairsConfigurationRequest, UpdateCurrencyPairsConfigurationResponse, RemoveExternalTransfersEntitiesConfigurationResponse, RemoveExternalTransfersEntitiesConfigurationRequest,
    RemoveClientConfigurationRequest,
    RemoveClientConfigurationResponse,
} from '../../../../repository/UserManagement/organizationclientportalsetting_pb';
import { TableState } from '../../../common/Table/TableSate';
import { DynamicField } from '../../../common/DynamicFields/DynamicFields';


export interface OrganizationClientPortalSettingPageState {
    item: any
    isChangeStateLoading: boolean,
    message?: ApiMessage,
    isLoading: boolean
    openAccountDefaultConfiguration: TableState,
    currencyPairsConfiguration: TableState,
    externalTransfersEntitiesConfiguration: TableState
    clientConfiguration: TableState,



}

const initialState: OrganizationClientPortalSettingPageState = {
    item: undefined,
    isChangeStateLoading: false,
    message: undefined,
    isLoading: false,
    clientConfiguration: { items: [], hasMore: true, isDescending: true, isFetching: false, numberOfResults: 10, selected: [], isFilteredSet: false },
    openAccountDefaultConfiguration: { items: [], hasMore: true, isDescending: true, isFetching: false, numberOfResults: 10, selected: [], isFilteredSet: false },
    currencyPairsConfiguration: { items: [], hasMore: true, isDescending: true, isFetching: false, numberOfResults: 10, selected: [], isFilteredSet: false },
    externalTransfersEntitiesConfiguration: { items: [], hasMore: true, isDescending: true, isFetching: false, numberOfResults: 10, selected: [], isFilteredSet: false },

}

const client = new OrganizationClientPortalSettingEndpointClient(API_URL, null, null);


export const getOrganizationClientPortalSetting = createAsyncThunk<GetOrganizationClientPortalSettingResponse.AsObject, APIRequest<GetOrganizationClientPortalSettingRequest>, {

    rejectValue: ApiMessage
}>(
    'pages/organizationClientPortalSetting/get',
    async (req, thunkApi) => {
        let callReq = async (): Promise<any> => {
            try {
                var r = await client.getOrganizationClientPortalSetting(req.body, req.headers ?? {});
                return r.toObject();
            } catch (err) {
                try {
                    let message = toApiMessage((err as RpcError).metadata);
                    if (message.data == 401) {
                        var isSessionRefreshed = await refreshSession();
                        if (isSessionRefreshed) {
                            req.headers = {
                                ...req.headers,
                                "Authorization": 'Bearer ' + getSession().accesstoken?.token?.value,
                            }
                            return await callReq();
                        }
                    }
                    return thunkApi.rejectWithValue(message)
                } catch (err) {

                    return thunkApi.rejectWithValue({ body: "genericErrorBody", data: "", title: "genericErrorTitle", type: -2 } as ApiMessage)
                }
            }
        }
        return await callReq();
    }

)




export const updateURLs = createAsyncThunk<APIResponse<UpdateURLsResponse.AsObject>, APIRequest<UpdateURLsRequest>, {

    rejectValue: ApiMessage
}>(
    'pages/organizationClientPortalSetting/updateURLs',
    async (req, thunkApi) => {
        let callReq = async (): Promise<any> => {
            try {
                var r = await client.updateURLs(req.body, req.headers ?? {});
                return { metadata: { id: req.body.getId(), terms: req.body.getTerms(), privacypolicy: req.body.getPrivacypolicy(), support: req.body.getSupport(), }, response: r.toObject() };
            } catch (err) {
                try {
                    let message = toApiMessage((err as RpcError).metadata);
                    if (message.data == 401) {
                        var isSessionRefreshed = await refreshSession();
                        if (isSessionRefreshed) {
                            req.headers = {
                                ...req.headers,
                                "Authorization": 'Bearer ' + getSession().accesstoken?.token?.value,
                            }
                            return await callReq();
                        }
                    }
                    return thunkApi.rejectWithValue(message)
                } catch (err) {

                    return thunkApi.rejectWithValue({ body: "genericErrorBody", data: "", title: "genericErrorTitle", type: -2 } as ApiMessage)
                }
            }
        }
        return await callReq();
    }

)




export const removeOpenAccountDefaultConfiguration = createAsyncThunk<APIResponse<RemoveOpenAccountDefaultConfigurationResponse.AsObject>, APIRequest<RemoveOpenAccountDefaultConfigurationRequest>, {

    rejectValue: ApiMessage
}>(
    'pages/organizationClientPortalSetting/removeOpenAccountDefaultConfiguration',
    async (req, thunkApi) => {
        let callReq = async (): Promise<any> => {
            try {
                var r = await client.removeOpenAccountDefaultConfiguration(req.body, req.headers ?? {});
                return { metadata: { id: req.body.getCurrency(), accountType: req.body.getAccounttype(), userType: req.body.getUsertype() }, response: r.toObject() };

            } catch (err) {
                try {
                    let message = toApiMessage((err as RpcError).metadata);
                    if (message.data == 401) {
                        var isSessionRefreshed = await refreshSession();
                        if (isSessionRefreshed) {
                            req.headers = {
                                ...req.headers,
                                "Authorization": 'Bearer ' + getSession().accesstoken?.token?.value,
                            }
                            return await callReq();
                        }
                    }
                    return thunkApi.rejectWithValue(message)
                } catch (err) {

                    return thunkApi.rejectWithValue({ body: "genericErrorBody", data: "", title: "genericErrorTitle", type: -2 } as ApiMessage)
                }
            }
        }
        return await callReq();
    }

)


export const removeCurrencyPairsConfiguration = createAsyncThunk<APIResponse<RemoveCurrencyPairsConfigurationResponse.AsObject>, APIRequest<RemoveCurrencyPairsConfigurationRequest>, {

    rejectValue: ApiMessage
}>(
    'pages/organizationClientPortalSetting/removeCurrencyPairsConfiguration',
    async (req, thunkApi) => {
        let callReq = async (): Promise<any> => {
            try {
                var r = await client.removeCurrencyPairsConfiguration(req.body, req.headers ?? {});
                return { metadata: { id: req.body.getCurrencypair() }, response: r.toObject() };

            } catch (err) {
                try {
                    let message = toApiMessage((err as RpcError).metadata);
                    if (message.data == 401) {
                        var isSessionRefreshed = await refreshSession();
                        if (isSessionRefreshed) {
                            req.headers = {
                                ...req.headers,
                                "Authorization": 'Bearer ' + getSession().accesstoken?.token?.value,
                            }
                            return await callReq();
                        }
                    }
                    return thunkApi.rejectWithValue(message)
                } catch (err) {

                    return thunkApi.rejectWithValue({ body: "genericErrorBody", data: "", title: "genericErrorTitle", type: -2 } as ApiMessage)
                }
            }
        }
        return await callReq();
    }

)


export const removeExternalTransfaresEntitesConfiguration = createAsyncThunk<APIResponse<RemoveExternalTransfersEntitiesConfigurationResponse.AsObject>, APIRequest<RemoveExternalTransfersEntitiesConfigurationRequest>, {

    rejectValue: ApiMessage
}>(
    'pages/organizationClientPortalSetting/removeExternalTransfaresEntitesConfiguration',
    async (req, thunkApi) => {
        let callReq = async (): Promise<any> => {
            try {
                var r = await client.removeExternalTransfersEntitiesConfiguration(req.body, req.headers ?? {});
                return { metadata: { id: req.body.getGwaccoint() }, response: r.toObject() };

            } catch (err) {
                try {
                    let message = toApiMessage((err as RpcError).metadata);
                    if (message.data == 401) {
                        var isSessionRefreshed = await refreshSession();
                        if (isSessionRefreshed) {
                            req.headers = {
                                ...req.headers,
                                "Authorization": 'Bearer ' + getSession().accesstoken?.token?.value,
                            }
                            return await callReq();
                        }
                    }
                    return thunkApi.rejectWithValue(message)
                } catch (err) {

                    return thunkApi.rejectWithValue({ body: "genericErrorBody", data: "", title: "genericErrorTitle", type: -2 } as ApiMessage)
                }
            }
        }
        return await callReq();
    }

)



export const updateCanSignUp = createAsyncThunk<APIResponse<UpdateCanSignUpResponse.AsObject>, APIRequest<UpdateCanSignUpRequest>, {

    rejectValue: ApiMessage
}>(
    'pages/organizationClientPortalSetting/updateCanSignUp',
    async (req, thunkApi) => {
        let callReq = async (): Promise<any> => {
            try {
                var r = await client.updateCanSignUp(req.body, req.headers ?? {});
                return { metadata: { id: req.body.getId(), state: req.body.getCansignup() }, response: r.toObject() };
            } catch (err) {
                try {
                    let message = toApiMessage((err as RpcError).metadata);
                    if (message.data == 401) {
                        var isSessionRefreshed = await refreshSession();
                        if (isSessionRefreshed) {
                            req.headers = {
                                ...req.headers,
                                "Authorization": 'Bearer ' + getSession().accesstoken?.token?.value,
                            }
                            return await callReq();
                        }
                    }
                    return thunkApi.rejectWithValue(message)
                } catch (err) {

                    return thunkApi.rejectWithValue({ body: "genericErrorBody", data: "", title: "genericErrorTitle", type: -2 } as ApiMessage)
                }
            }
        }
        return await callReq();
    }

)

export const removeClientConfiguration = createAsyncThunk<APIResponse<RemoveClientConfigurationResponse.AsObject>, APIRequest<RemoveClientConfigurationRequest>, {

    rejectValue: ApiMessage
}>(
    'pages/organizationClientPortalSetting/removeClientConfiguration',
    async (req, thunkApi) => {
        let callReq = async (): Promise<any> => {
            try {
                var r = await client.removeClientConfiguration(req.body, req.headers ?? {});
                return { metadata: { id: req.body.getId(), userType: req.body.getUsertype() }, response: r.toObject() };
            } catch (err) {
                try {
                    let message = toApiMessage((err as RpcError).metadata);
                    if (message.data == 401) {
                        var isSessionRefreshed = await refreshSession();
                        if (isSessionRefreshed) {
                            req.headers = {
                                ...req.headers,
                                "Authorization": 'Bearer ' + getSession().accesstoken?.token?.value,
                            }
                            return await callReq();
                        }
                    }
                    return thunkApi.rejectWithValue(message)
                } catch (err) {

                    return thunkApi.rejectWithValue({ body: "genericErrorBody", data: "", title: "genericErrorTitle", type: -2 } as ApiMessage)
                }
            }
        }
        return await callReq();
    }

)











export const organizationClientPortalSettingPageSlice = createSlice({
    name: 'pages/organizationClientPortalSetting',
    initialState,
    reducers: {
        dismissMessage: (state) => {
            state.message = undefined;
        },
        reset: (state) => {
            state.message = initialState.message;
            state.isChangeStateLoading = initialState.isChangeStateLoading;
            state.item = initialState.item;
            state.clientConfiguration = initialState.clientConfiguration;
            state.openAccountDefaultConfiguration = initialState.openAccountDefaultConfiguration;
            state.currencyPairsConfiguration = initialState.currencyPairsConfiguration;
            state.externalTransfersEntitiesConfiguration = initialState.externalTransfersEntitiesConfiguration;

        },
        setSelectedAccountConfig: (state, action: PayloadAction<any[]>) => {
            state.openAccountDefaultConfiguration.selected = action.payload;
        },

        addAccountConfig: (state, action: PayloadAction<any>) => {

            let selected = state.openAccountDefaultConfiguration.selected;
            if (action?.payload) {
                if (selected.length > 0 && selected.at(0).currencyId == action?.payload?.currencyId && selected.at(0).accountTypeId == action?.payload?.accountTypeId && selected.at(0).userTypeId == action?.payload?.userTypeId) {
                    selected[0] = action?.payload
                }
                var u = state.openAccountDefaultConfiguration.items.findIndex(e => e.currencyId == action?.payload?.currencyId && e.accountTypeId == action?.payload?.accountTypeId && e.userTypeId == action?.payload?.userTypeId)
                var u2 = state.item?.openAccountDefaultConfiguration?.findIndex((e: any) => e.currencyId == action?.payload?.currencyId && e.accountTypeId == action?.payload?.accountTypeId && e.userTypeId == action?.payload?.userTypeId);
                if (u > 0) {
                    state.openAccountDefaultConfiguration.items[u] = action?.payload
                } else {
                    state.openAccountDefaultConfiguration.items.push(action.payload);

                }
                if (u2 > 0) {
                    state.item.openAccountDefaultConfiguration[u2] = action?.payload
                } else {
                    state.item.openAccountDefaultConfiguration.push(action.payload);
                }

            }


        },
        updateAccountConfig: (state, action: PayloadAction<any>) => {

            let selected = state.openAccountDefaultConfiguration.selected;
            if (action?.payload) {
                if (selected.length > 0 && selected.at(0).currencyId == action?.payload?.currencyId && selected.at(0).accountTypeId == action?.payload?.accountTypeId && selected.at(0).userTypeId == action?.payload?.userTypeId) {
                    selected[0] = action?.payload
                }
                var u = state.openAccountDefaultConfiguration.items.findIndex(e => e.currencyId == action?.payload?.currencyId && e.accountTypeId == action?.payload?.accountTypeId && e.userTypeId == action?.payload?.userTypeId)
                var u2 = state.item?.openAccountDefaultConfiguration?.findIndex((e: any) => e.currencyId == action?.payload?.currencyId && e.accountTypeId == action?.payload?.accountTypeId && e.userTypeId == action?.payload?.userTypeId);
                if (u > 0) {
                    state.openAccountDefaultConfiguration.items[u] = action?.payload
                } else {
                    state.openAccountDefaultConfiguration.items.push(action.payload);

                }
                if (u2 > 0) {
                    state.item.openAccountDefaultConfiguration[u2] = action?.payload
                } else {
                    state.item.openAccountDefaultConfiguration.push(action.payload);
                }

            }


        },

        setSelectedCurrencyPairConfig: (state, action: PayloadAction<any[]>) => {
            state.currencyPairsConfiguration.selected = action.payload;
        },

        setSelectedExternalTransferEntityConfig: (state, action: PayloadAction<any[]>) => {
            state.externalTransfersEntitiesConfiguration.selected = action.payload;
        },
        addExternalTransferEntityConfig: (state, action: PayloadAction<any>) => {
            state.externalTransfersEntitiesConfiguration.items.push(action.payload);
            state.item.externalTransfersEntitiesConfiguration.push(action.payload);
        },

        updateExternalTransferEntityConfig: (state, action: PayloadAction<any>) => {
            let selected = state.externalTransfersEntitiesConfiguration.selected;
            if (action?.payload) {
                if (selected.length > 0 && selected.at(0).gwAccountInternalId == action?.payload?.gwAccountInternalId) {
                    selected[0] = action?.payload
                }
                var u = state.externalTransfersEntitiesConfiguration.items.findIndex(e => e.gwAccountInternalId == action?.payload?.gwAccountInternalId)
                if (u >= 0) {
                    state.externalTransfersEntitiesConfiguration.items[u] = action?.payload
                }
            }

        },
        addClientConfig: (state, action: PayloadAction<any>) => {
            state.clientConfiguration.items.push(action.payload);
            state.item.clientConfiguration.push(action.payload);
            if (action?.payload?.isDefault == true) {
                var i = 0;
                state.clientConfiguration.items.forEach(e => {
                    if (e.userTypeId != action?.payload?.userTypeId) {
                        state.clientConfiguration.items[i].isDefault = false
                    }
                    i++;
                })
            }
        },
        setClientConfig: (state, action: PayloadAction<any[]>) => {
            state.clientConfiguration.selected = action.payload;
        },

        updateClientConfig: (state, action: PayloadAction<any>) => {
            let selected = state.clientConfiguration.selected;
            if (action?.payload) {
                if (selected.length > 0 && selected.at(0).userTypeId == action?.payload?.userTypeId) {
                    selected[0] = action?.payload

                }
                var u = state.clientConfiguration.items.findIndex(e => e.userTypeId == action?.payload?.userTypeId)
                if (u >= 0) {
                    state.clientConfiguration.items[u] = action?.payload
                }
                if (action?.payload?.isDefault == true) {
                    var i = 0;
                    state.clientConfiguration.items.forEach(e => {
                        if (e.userTypeId != action?.payload?.userTypeId) {
                            state.clientConfiguration.items[i].isDefault = false
                        }
                        i++;
                    })
                }
            }

        },
        addCurrencyPairConfig: (state, action: PayloadAction<any>) => {
            state.currencyPairsConfiguration.items.push(action.payload);
            state.item.currencyPairsConfiguration.push(action.payload);

        },
        updateCurrencyPairConfig: (state, action: PayloadAction<any>) => {
            let selected = state.currencyPairsConfiguration.selected;
            if (action?.payload) {
                if (selected.length > 0 && selected.at(0).currencyPairId == action?.payload?.currencyPairId) {
                    selected[0] = action?.payload
                }
                var u = state.currencyPairsConfiguration.items.findIndex(e => e.currencyPairId == action?.payload?.currencyPairId)
                if (u >= 0) {
                    state.currencyPairsConfiguration.items[u] = action?.payload
                }
            }

        },

        resetItem: (state) => {
            state.item = undefined;

        },







        updateItem: (state, action: PayloadAction<any>) => {
            state.item = action.payload;
        },
        resetMessage: (state) => {
            state.message = undefined;
        },
    },
    extraReducers: (builder) => {
        builder.addCase(getOrganizationClientPortalSetting.fulfilled, (state, { payload }) => {
            state.isLoading = false
            if (payload) {

                var r = {
                    id: payload.success?.id,
                    canSignup: (payload.success?.cansignup?.value),
                    isActive: payload.success?.isactive?.value,

                    privacyPolicy: payload.success?.privacypolicy?.value ?? "",
                    terms: payload.success?.terms?.value ?? "",
                    support: payload.success?.support?.value ?? "",


                    clientConfiguration: [] as any[],
                    openAccountDefaultConfiguration: [] as any[],
                    currencyPairsConfiguration: [] as any[],
                    externalTransfersEntitiesConfiguration: [] as any[],
                    createdDate: formatDate(timestampToDate(payload.success?.createddate?.seconds, payload.success?.createddate?.nanos)),
                    addedBy: (payload.success?.createdby?.firstname?.value ?? "") + " " + (payload.success?.createdby?.lastname?.value ?? ""),
                    addedById: payload.success?.createdby?.id?.value,

                }

                if (payload?.success?.clientconfigurationsList) {
                    payload?.success?.clientconfigurationsList?.forEach(element => {

                        let item = {
                            roleId: element?.role?.id,
                            roleName: element?.role?.name?.value,
                            userTypeId: element?.usertype?.id,
                            userTypeName: element?.usertype?.name?.value,
                            canOpenAccount: element?.canopenaccount,
                            name: element?.typename ?? "",
                            isAccountLockedByDefault: element?.isaccountlockedbydefault,
                            isIdentityVerificationRequired: element?.isidentityverificationrequired,
                            identityVerificationDocuments: [] as DynamicField[],
                            isDefault: element?.isdefault,
                            groupId: element?.group?.id,
                            groupName: element?.group?.name?.value,


                        }


                        if (element?.identityverificationdocumentsList) {
                            let count = 0
                            element?.identityverificationdocumentsList?.forEach(e => {
                                item.identityVerificationDocuments.push({ key: count + "", label: undefined, type: 1, value: e.value })
                                count++
                            });
                        }

                        r.clientConfiguration.push(item);
                    });
                }
                state.clientConfiguration.items = r.clientConfiguration;
                state.clientConfiguration.hasMore = false;


                if (payload?.success?.openaccountdefaultconfigurationsList) {
                    payload?.success?.openaccountdefaultconfigurationsList?.forEach(element => {

                        let item = {
                            accountTypeId: element.accounttype?.id,
                            accountTypeName: element.accounttype?.name?.value ?? "",
                            currencyId: element.currency?.id,
                            currencyName: element.currency?.name?.value,
                            limitationId: element.limitation?.id,
                            limitationName: element.limitation?.name?.value,
                            maxNumberOfAccounts: element.maxnumberofaccountscanbeopend?.value ?? 0,
                            openByDefault: element.openbydefault?.value,
                            rank: element.rank?.value,
                            canUpdateName: element.canupdatename?.value,
                            canUpdateCode: element.canupdatecode?.value,
                            userTypeId: element?.usertype?.id,
                            userTypeName: element?.usertype?.name?.value,


                        }


                        r.openAccountDefaultConfiguration.push(item);
                    });
                }

                state.openAccountDefaultConfiguration.items = r.openAccountDefaultConfiguration;
                state.openAccountDefaultConfiguration.hasMore = false;



                if (payload?.success?.currencypairsconfigurationsList) {
                    payload?.success?.currencypairsconfigurationsList?.forEach(element => {

                        let item = {
                            currencyPairId: element.currencypair?.id,
                            currencyPairName: element.currencypair?.name?.value ?? "",
                            currencyPairBaseId: element.currencypair?.base?.id,
                            currencyPairBaseName: element.currencypair?.base?.name?.value ?? "",
                            currencyPairQuoteId: element.currencypair?.quote?.id,
                            currencyPairQuoteName: element.currencypair?.quote?.name?.value ?? "",
                            rank: element.rank?.value,
                        }


                        r.currencyPairsConfiguration.push(item);
                    });
                }

                state.currencyPairsConfiguration.items = r.currencyPairsConfiguration;
                state.currencyPairsConfiguration.hasMore = false;

                if (payload?.success?.externaltransfersentitiesconfigurationsList) {
                    payload?.success?.externaltransfersentitiesconfigurationsList?.forEach(element => {

                        let item = {
                            name: element.name?.value ?? "",
                            gwAccountInternalId: element.gwaccount?.internalid,
                            gwAccountId: element.gwaccount?.id,
                            gwAccountCurrencyId: element.gwaccount?.currency?.id,
                            gwAccountCurrencyName: element.gwaccount?.currency?.name?.value ?? "",
                        }


                        r.externalTransfersEntitiesConfiguration.push(item);
                    });
                }

                state.externalTransfersEntitiesConfiguration.items = r.externalTransfersEntitiesConfiguration;
                state.externalTransfersEntitiesConfiguration.hasMore = false;

                state.item = r;

            }
        })
        builder.addCase(getOrganizationClientPortalSetting.rejected, (state, action) => {
            state.isLoading = false;
            if (action.payload) {
                state.message = action.payload;
            }
        })
        builder.addCase(getOrganizationClientPortalSetting.pending, (state, action) => {
            state.isLoading = true;
            state.message = undefined;
        })











        builder.addCase(updateCanSignUp.fulfilled, (state, { payload }) => {
            state.isChangeStateLoading = false;
            if (payload) {
                state.message = toApiMessage(payload?.response.success?.message);
                state.item.canSignup = payload?.metadata.state
            }

        })
        builder.addCase(updateCanSignUp.rejected, (state, action) => {
            state.isChangeStateLoading = false;
            if (action.payload) {
                state.message = action.payload;
            }
        })
        builder.addCase(updateCanSignUp.pending, (state, action) => {
            state.isChangeStateLoading = true;
            state.message = undefined;
        })





        builder.addCase(updateURLs.fulfilled, (state, { payload }) => {
            state.isLoading = false;
            if (payload) {
                state.message = toApiMessage(payload?.response?.success?.message);
                state.item.terms = payload?.metadata?.terms
                state.item.privacyPolicy = payload?.metadata?.privacyPolicy
                state.item.support = payload?.metadata?.support

            }
        })
        builder.addCase(updateURLs.rejected, (state, action) => {
            state.isLoading = false;
            if (action.payload) {
                state.message = action.payload;
            }
        })
        builder.addCase(updateURLs.pending, (state, action) => {
            state.isLoading = true;
            state.message = undefined;
        })

        builder.addCase(removeOpenAccountDefaultConfiguration.fulfilled, (state, { payload }) => {
            state.isLoading = false;
            state.isChangeStateLoading = false;

            if (payload) {
                state.message = toApiMessage(payload?.response.success?.message);
                if (payload?.metadata) {
                    var u = state.item?.openAccountDefaultConfiguration?.findIndex((e: any) => e.currencyId == payload?.metadata.id && e.accountTypeId == payload?.metadata.accountType && e.userTypeId == payload?.metadata?.userType);
                    var u2 = state.openAccountDefaultConfiguration?.items.findIndex((e: any) => e.currencyId == payload?.metadata.id && e.accountTypeId == payload?.metadata.accountType && e.userTypeId == payload?.metadata?.userType);
                    if (u >= 0) {
                        state.item?.openAccountDefaultConfiguration.splice(u, 1);
                    }
                    if (u2 >= 0) {
                        state.openAccountDefaultConfiguration?.items?.splice(u, 1);
                    }

                }
            }
        })
        builder.addCase(removeOpenAccountDefaultConfiguration.rejected, (state, action) => {
            state.isLoading = false;
            state.isChangeStateLoading = false;

            if (action.payload) {
                state.message = action.payload;
            }
        })
        builder.addCase(removeOpenAccountDefaultConfiguration.pending, (state, action) => {
            state.isLoading = true;
            state.isChangeStateLoading = true;

            state.message = undefined;
        })


        builder.addCase(removeCurrencyPairsConfiguration.fulfilled, (state, { payload }) => {
            state.isLoading = false;
            state.isChangeStateLoading = false;

            if (payload) {
                state.message = toApiMessage(payload?.response.success?.message);
                if (payload?.metadata) {
                    var u = state.item?.currencyPairsConfiguration?.findIndex((e: any) => e.currencyPairId == payload?.metadata.id);
                    var u2 = state.currencyPairsConfiguration?.items.findIndex((e: any) => e.currencyPairId == payload?.metadata.id);
                    if (u >= 0) {
                        state.item?.currencyPairsConfiguration.splice(u, 1);
                    }
                    if (u2 >= 0) {
                        state.currencyPairsConfiguration?.items?.splice(u, 1);
                    }

                }
            }
        })
        builder.addCase(removeCurrencyPairsConfiguration.rejected, (state, action) => {
            state.isLoading = false;
            state.isChangeStateLoading = false;
            if (action.payload) {
                state.message = action.payload;
            }
        })
        builder.addCase(removeCurrencyPairsConfiguration.pending, (state, action) => {
            state.isLoading = true;
            state.isChangeStateLoading = true;

            state.message = undefined;
        })
        builder.addCase(removeExternalTransfaresEntitesConfiguration.fulfilled, (state, { payload }) => {
            state.isLoading = false;
            state.isChangeStateLoading = false;

            if (payload) {
                state.message = toApiMessage(payload?.response.success?.message);
                if (payload?.metadata) {
                    var u = state.item?.externalTransfersEntitesConfiguration?.findIndex((e: any) => e.gwAccountInternalId == payload?.metadata.id);
                    var u2 = state.externalTransfersEntitiesConfiguration?.items.findIndex((e: any) => e.gwAccountInternalId == payload?.metadata.id);
                    if (u >= 0) {
                        state.item?.externalTransfersEntitesConfiguration.splice(u, 1);
                    }
                    if (u2 >= 0) {
                        state.externalTransfersEntitiesConfiguration?.items?.splice(u, 1);
                    }

                }
            }
        })
        builder.addCase(removeExternalTransfaresEntitesConfiguration.rejected, (state, action) => {
            state.isLoading = false;
            state.isChangeStateLoading = false;
            if (action.payload) {
                state.message = action.payload;
            }
        })
        builder.addCase(removeExternalTransfaresEntitesConfiguration.pending, (state, action) => {
            state.isLoading = true;
            state.isChangeStateLoading = true;

            state.message = undefined;
        })

        builder.addCase(removeClientConfiguration.fulfilled, (state, { payload }) => {
            state.isLoading = false;
            state.isChangeStateLoading = false;

            if (payload) {
                state.message = toApiMessage(payload?.response.success?.message);
                if (payload?.metadata) {
                    var u = state.item?.clientConfiguration?.findIndex((e: any) => e.userTypeId == payload?.metadata.userType);
                    var u2 = state.clientConfiguration?.items.findIndex((e: any) => e.userTypeId == payload?.metadata.userType);
                    if (u >= 0) {
                        state.item?.clientConfiguration.splice(u, 1);
                    }
                    if (u2 >= 0) {
                        state.clientConfiguration?.items?.splice(u, 1);
                    }

                }
            }
        })
        builder.addCase(removeClientConfiguration.rejected, (state, action) => {
            state.isLoading = false;
            state.isChangeStateLoading = false;

            if (action.payload) {
                state.message = action.payload;
            }
        })
        builder.addCase(removeClientConfiguration.pending, (state, action) => {
            state.isLoading = true;
            state.isChangeStateLoading = true;

            state.message = undefined;
        })



    }
})

export const { reset, dismissMessage, addAccountConfig, resetMessage, setClientConfig, addClientConfig, updateClientConfig, updateExternalTransferEntityConfig, addExternalTransferEntityConfig, addCurrencyPairConfig, setSelectedExternalTransferEntityConfig, setSelectedCurrencyPairConfig, updateCurrencyPairConfig, updateAccountConfig, setSelectedAccountConfig, resetItem, updateItem, } = organizationClientPortalSettingPageSlice.actions

export default organizationClientPortalSettingPageSlice.reducer